export const notificationTypes = {
  UNSTABLE_CONNECTION: {
    CODE: '222001',
    AUTO_HIDE: false
  },
};
